module.exports = __webpack_public_path__ + "static/media/StandartPadrao.8f58ae41.png";